export default {
  methods: {
    textStyles: function textStyles(spec) {
      var styles = this.$styles(spec);

      switch (this.spec.textAlign) {
        case "center":
          styles["text-align"] = "center";
          break;

        case "right":
          styles["text-align"] = "right";
          break;

        default:
          styles["text-align"] = "left";
      }

      return styles;
    }
  }
};